import { render, staticRenderFns } from "./ProgrammedActivityList.vue?vue&type=template&id=fe636136&scoped=true&"
import script from "./ProgrammedActivityList.vue?vue&type=script&lang=js&"
export * from "./ProgrammedActivityList.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammedActivityList.vue?vue&type=style&index=0&id=fe636136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe636136",
  null
  
)

export default component.exports